import { render } from "./ContainerDeleteDialog.vue?vue&type=template&id=dce25e5c"
import script from "./ContainerDeleteDialog.vue?vue&type=script&lang=js"
export * from "./ContainerDeleteDialog.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__